import {
  LOAD_CAMPAIGNS_SUCCESS,
  LOAD_CAMPAIGNS_ERROR,
  LOAD_CAMPAIGNS,
  SET_CAMPAIGN_PERMISSION,
  SET_PERMISSION_STATUS,
  UPDATE_SHOW_CAMPAIGNS_LIST,
} from './constants';

export function setPermissionStatus(campaignPermissionId, campaignId, status) {
  return {
    type: SET_PERMISSION_STATUS,
    campaignPermissionId,
    campaignId,
    status,
  };
}

export function loadingCampaignsList() {
  return {
    type: LOAD_CAMPAIGNS,
  };
}

export function loadCampaignsError(error) {
  return {
    type: LOAD_CAMPAIGNS_ERROR,
    error,
  };
}

export function loadingCampaignsSuccess(campaigns) {
  return {
    type: LOAD_CAMPAIGNS_SUCCESS,
    campaigns,
  };
}

export function setCampaignPermission(campaignPermission) {
  return {
    type: SET_CAMPAIGN_PERMISSION,
    campaignPermission,
  };
}

export function updateShowCampaignsList(campaignPermissionStatus) {
  return {
    type: UPDATE_SHOW_CAMPAIGNS_LIST,
    campaignPermissionStatus,
  };
}



/** WEBPACK FOOTER **
 ** ./src/containers/influencers-campaign-list/actions.js
 **/